import { apiClient } from './client';
import type { AccountStagingItem, AccountStagingStatus } from '@/types/oscar';

/**
 * Pending Entra accounts (oscar/api/Functions/AccountStagingFunctions.cs) — the
 * "accounts to add" surface fed by the account sync. Admin / helpdesk only.
 */
export function listAccountStaging(status?: AccountStagingStatus, signal?: AbortSignal): Promise<AccountStagingItem[]> {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return apiClient.get<AccountStagingItem[]>(`/api/account-staging${q}`, signal);
}

/** Promote a staged account to a Person / SystemAccount using the chosen Account Type. */
export function addAccountFromStaging(id: number, accountTypeCode: string): Promise<{ CreatedKind: string; CreatedId: number }> {
  return apiClient.post<{ CreatedKind: string; CreatedId: number }>(`/api/account-staging/${id}/add`, { AccountTypeCode: accountTypeCode });
}

/** Triage a staged account (Ignore, or verify a disabled one back to New). */
export function patchAccountStaging(id: number, body: { TriageStatus?: AccountStagingStatus; Notes?: string }): Promise<AccountStagingItem> {
  return apiClient.patch<AccountStagingItem>(`/api/account-staging/${id}`, body);
}

/** One-time bulk add: promote every enabled (New) staged account by its suggested type. Admin only. */
export interface AddAllResult { Added: number; SkippedNoType: number; SkippedNoEmail: number; Failed: number }
export function addAllFromStaging(): Promise<AddAllResult> {
  return apiClient.post<AddAllResult>('/api/account-staging/add-all');
}
